import { put, select, takeLatest } from 'typed-redux-saga/macro';
import { selectSelectedSpace, selectDefaultSpaceId, } from 'features/spaces/reducers/selectors';
import { getSpacePots } from 'features/pots/actions';
import { getSpaceTradingAccounts } from 'actions/invest';
function* fetchSpacePotsWorker() {
    const spaceId = yield* select(selectSelectedSpace);
    const defaultSpaceId = yield* select(selectDefaultSpaceId);
    const spaceToFetch = spaceId || defaultSpaceId;
    if (spaceToFetch) {
        yield* put(getSpacePots(spaceToFetch));
    }
}
function* fetchSpaceInvestAccountsWorker() {
    const spaceId = yield* select(selectSelectedSpace);
    const defaultSpaceId = yield* select(selectDefaultSpaceId);
    const spaceToFetch = spaceId || defaultSpaceId;
    if (spaceToFetch) {
        yield* put(getSpaceTradingAccounts(spaceToFetch));
    }
}
function* overviewSaga() {
    yield* takeLatest((action) => [
        'GET_POTS_SUCCESS',
        'WITHDRAW_SUCCESS',
        'REOPEN_POT_SUCCESS',
        'DELETE_POT_SUCCESS',
        'WITHDRAW_POT_TO_CONNECTED_ACCOUNT_SUCCESS',
    ].includes(action.type), fetchSpacePotsWorker);
    yield* takeLatest((action) => [
        'GET_TRADING_ACCOUNTS_SUCCESS',
        'CLOSE_USER_TRADING_ACCOUNT_SUCCESS_ACTION',
    ].includes(action.type), fetchSpaceInvestAccountsWorker);
}
export default overviewSaga;
